import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { CustomizerSettingsService } from '../../customizer-settings/customizer-settings.service';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { UserService } from '../../common/services/user.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { StorageService } from '../../common/services/storage.service';
import { ChangePassword, CurrentUser } from '../../common/models/user';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-change-password',
    imports: [MatButtonModule, MatFormFieldModule, MatInputModule, ReactiveFormsModule],
    templateUrl: './change-password.component.html',
    styleUrl: './change-password.component.scss'
})
export class ChangePasswordComponent implements OnInit, OnDestroy {
    private destroy$ = new Subject<void>();

    // Password Hide
    hide = true;
    hide2 = true;
    hide3 = true;

    changePasswordForm: FormGroup;
    isToggled = false;

    user: CurrentUser | null = null;

    constructor(
        private fb: FormBuilder,
        private userService: UserService,
        private storageService: StorageService,
        private snackBar: MatSnackBar,
        public themeService: CustomizerSettingsService
    ) {
        this.changePasswordForm = this.fb.group({
            oldPassword: ['', Validators.required],
            newPassword: ['', [Validators.required, Validators.minLength(8)]],
            confirmPassword: ['', Validators.required]
        });

        this.themeService.isToggled$.pipe(takeUntil(this.destroy$)).subscribe(isToggled => {
            this.isToggled = isToggled;
        });
    }

    ngOnInit(): void {
        this.user = this.storageService.getUser();
    }

    ngOnDestroy() {
      this.destroy$.next();
      this.destroy$.complete();
    }

    changePassword(): void {
        if (this.changePasswordForm.valid) {
            const { oldPassword, newPassword, confirmPassword } = this.changePasswordForm.value;

            if (newPassword !== confirmPassword) {
                this.snackBar.open('Nova lozinka i potvrda lozinke se ne podudaraju.', 'Zatvori', {
                    duration: 3000,
                });
                return;
            }

            const dto: ChangePassword = {
                oldPassword: oldPassword,
                newPassword: newPassword
            };

            this.userService.changePassword(dto).pipe(takeUntil(this.destroy$)).subscribe({
                next: () => {
                    this.snackBar.open('Lozinka je uspješno promijenjena.', 'Zatvori', {
                        duration: 3000,
                    });
                },
                error: () => {
                    this.snackBar.open('Dogodila se pogreška prilikom promjene lozinke.', 'Zatvori', {
                        duration: 3000,
                    });
                }
            });
        }
    }
}